import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import {
  InvoiceWithRelationsDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { invoicesKeys } from "../invoices.utils"

export type UseInvoicesParams = QueryParamsDto

export const useInvoices = (
  params?: UseInvoicesParams,
  options?: UseQueryOptions<ResponseDto<InvoiceWithRelationsDto[]>, Error>
): UseQueryResult<ResponseDto<InvoiceWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useInvoices")

  const { server } = useServerContext()

  return useQuery({
    queryKey: invoicesKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<InvoiceWithRelationsDto[]>>(
        buildQueryString("invoices", params)
      )
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    ...options,
  })
}
